export default __webpack_public_path__ + "static/media/ic_chevron_right_black_24px.4d9d4e3d.svg";